const blogs = [
  {
    slug: "ai-digital-marketing-2026",
    title: "How AI Is Changing Digital Marketing",
    excerpt: "Explore how AI is transforming marketing with personalization, automation, and predictive analytics.",
    file: "ai-digital-marketing-2026.md",
    image: "/images/ai-marketing.jpg"
  },
  {
    slug: "top-10-seo-mistakes",
    title: "Top 10 SEO Mistakes Killing Your Website Traffic",
    excerpt: "Discover the most common SEO mistakes that hurt your rankings and learn how to fix them to boost traffic and conversions.",
    image: "/images/blog2.jpg",
    content: "Detailed explanation..."
  },
  {
    slug: "most-business-lose-add",
    title: "Why Most Businesses Lose Money on Ads",
    excerpt: "Learn the real reasons businesses lose money on advertising and how to fix poor targeting, weak offers, and ineffective funnels.",
    image: "/images/blog-ads-loss.jpg",
    content: "A deep dive into why ad campaigns fail despite getting clicks and impressions. Covers key issues like misunderstanding metrics (CAC, LTV), poor audience targeting, weak offers, lack of funnel strategy, no testing, creative fatigue, vanity metrics, low-converting landing pages, missing retargeting, and unrealistic expectations. Also explains how to fix these problems with data-driven strategies, proper funnels, and continuous optimization."
  },
  {
    slug: "psychology-behind-viral-marketing",
    title: "The Psychology Behind Viral Marketing Campaigns",
    excerpt: "Discover why some marketing campaigns explode across the internet while others fail, and learn the psychological triggers behind viral content.",
    file: "psychology-behind-viral-marketing.md",
    image: "/images/viral-marketing.jpg"
  },
  {
    slug: "marketing-funnels-explained-for-beginners",
    title: "Marketing Funnels Explained for Beginners",
    excerpt: "Learn what marketing funnels are, how they work, and why they are essential for attracting leads, building trust, and increasing sales.",
    file: "marketing-funnels-explained-for-beginners.md",
    image: "/images/marketing-funnels.jpg"
  }
];

export default blogs;